<template>
  <!-- 字典项管理页面 -->
  <div class="main-content" v-loading="loading">
    <!-- 标题 -->
    <div class="text_title left">
      <!-- <span>字典项数据</span> -->
      <span class="back" @click="back">
        <i class="el-icon-back"></i>返回
      </span>
    </div>
    <!-- 字典项搜索栏 -->
    <search-box :searchList="searchList" @search="searchDictionary" @add="addItemDictionary('ruleForm')" @del="deleteDictionaries" @reset="resetSearch" :selectIds="selectIds" />
    <!-- 操作按钮弹框 -->
     <ButtonDialog ref="buttonDialog" :modelValue="dialogFormVisible" :dialogTitle="dialogTitle" :dialogWidth="dialogWidth" @update:modelValue="dialogFormVisible = $event" @confirm="submitForm('ruleForm')">
      <slot>
        <el-form label-position="right" label-width="100px" :model="formLabelAlign" :rules="rules" ref="ruleForm">
          <el-form-item label="字典编码" prop="dictCode">
            <el-tag type="info">{{ listBtnShow }}</el-tag>
          </el-form-item>
          <el-form-item label="字典项名称" prop="itemName">
            <el-input v-model="formLabelAlign.itemName" placeholder="请输入字典项名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="字典项编码" prop="itemCode">
            <el-input v-model="formLabelAlign.itemCode" placeholder="请输入字典项编码" clearable></el-input>
          </el-form-item>
          <el-form-item label="字典项值" prop="itemValue">
            <el-input v-model="formLabelAlign.itemValue" placeholder="请输入字典项值" clearable></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="formLabelAlign.status" style="width: 100%;">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="字典项描述" prop="description">
            <el-input type="textarea" :rows="2" v-model="formLabelAlign.description" placeholder="请输入字典项描述" maxlength="30" show-word-limit></el-input>
          </el-form-item>
        </el-form>
      </slot>
    </ButtonDialog>
    <!-- 字典项总表+分页器 -->
    <dictionary-table id="table" ref="table" :tableList="tableList" :table-data="tableData" @handleEdit="handleEdit" @handleDelete="handleDelete" :total="total" :page-size="size" :currentPage="page" @handleSelect="handleSelect" @pagechange="pageChange" @sizeChange="sizeChange" @select="handleSelect" />
  </div>
</template>

<script>
import SearchBox from '@/components/table/SearchBox.vue'
import { dictionaryChildrenManageList } from '@/data/tableList'
import { addItemDictionary, deleteItemDictionary, getItemDictionary, updateItemDictionary } from '@/api/dictionary/dictionary'
import DictionaryTable from '@/tables/DictionaryTable.vue'
import ButtonDialog from '@/components/dialog/ButtonDialog.vue'

export default {
  name: 'DictionaryDataView',
  components: {
    SearchBox,
    DictionaryTable,
    ButtonDialog
  },
  data () {
    return {
      // 表头列表
      tableList: dictionaryChildrenManageList,
      // 搜索栏列表
      searchList: dictionaryChildrenManageList,
      // 字典项列表数据
      tableData: [],
      // 选中的字典项 id
      selectIds: [],
      // 每页显示的数量
      size: 10,
      // 当前页码
      page: 1,
      // 总数量
      total: 0,
      // 字典项弹窗是否显示
      dialogFormVisible: false,
      // 字典项弹窗标题
      dialogTitle: '',
      // 字典项弹窗宽度
      dialogWidth: '30%',
      formLabelAlign: {
        itemName: '',
        itemCode: '',
        dictCode: '',
        itemValue: '',
        status: true,
        description: ''
      },
      rules: {
        itemName: [
          { required: true, message: '请输入字典项名称', trigger: 'blur' }
        ],
        itemCode: [
          { required: true, message: '请输入字典项编码', trigger: 'blur' }
        ],
        itemValue: [
          { required: true, message: '请输入字典项编码', trigger: 'blur' }
        ]
      },
      options: [
        { value: true, label: '启用' },
        { value: false, label: '禁用' }
      ],
      listBtnShow: this.$route.query.dictCode,
      loading: false
    }
  },
  watch: {
    '$route.query.dictCode' (val) {
      this.getItemDictionaryList()
    }
  },
  mounted () {
    // 获取字典项列表
    this.getItemDictionaryList()
    // 字典下拉框赋值
    this.$assignDictOptions(this.searchList, { status: 'dictionary_status' }, this.selectDictionary)
  },
  computed: {
    selectDictionary () {
      return this.$store.getters.getDictionaryList
    }
  },
  methods: {
    // 获取字典项列表
    async getItemDictionaryList () {
      this.loading = true
      try {
        const res = await getItemDictionary({ page: this.page, size: this.size, dictCode: this.$route.query.dictCode })
        if (res.code === 200) {
          this.tableData = res.data.records
          this.total = res.data.total
        }
        this.loading = false
      } catch (error) {
        console.error(error)
      } finally{
        this.loading = false
      }
    },
    resetSearch () {
      this.getItemDictionaryList()
    },
    // 选择字典项
    handleSelect (selection) {
      this.selectIds = selection.map(item => item.id)
    },
    // 分页器
    pageChange (val) {
      this.page = val
      this.getItemDictionaryList()
    },
    // 页码大小改变
    sizeChange (val) {
      this.size = val
      this.getItemDictionaryList()
    },
    // 表格操作栏按钮 - 编辑
    async handleEdit (rawObject) {
      this.dialogTitle = '编辑字典项'
      // 创建深拷贝对象，避免直接引用表格数据
      const copyData = JSON.parse(JSON.stringify(rawObject))

      // 状态转换（根据显示文本转换为布尔值）
      copyData.status = copyData.status === 1

      // 使用拷贝后的数据
      this.formLabelAlign = copyData
      this.dialogFormVisible = true
    },
    // 操作栏按钮 - 单个删除
    handleDelete (rawObject) {
      this.$msgbox({
        title: '提示',
        message: '是否删除该字典项?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(async () => {
        const res = await deleteItemDictionary(rawObject.id)
        if (res.code === 200) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getItemDictionaryList()
        } else {
          this.$message({
            message: '删除失败',
            type: 'error'
          })
        }
      }).catch(() => {})
    },
    // 批量删除
    async deleteDictionaries (val) {
      const success = await this.$deleteHandler(deleteItemDictionary, this.selectIds, '字典项', val)
      if (success) {
        this.selectIds = []
        this.getItemDictionaryList()
      }
    },
    // 搜索字典项
    async searchDictionary (searchData) {
      this.loading = true
      this.tableData = []
      this.page = 1
      try {
        const data = { page: this.page, size: this.size, dictCode: this.$route.query.dictCode }
        const apiParams = { ...searchData, updateTime: undefined }
        const resData = await this.$searchHandler(getItemDictionary, apiParams, data)
        if (resData.code === 200) {
          this.tableData = resData.data.records
          this.total = resData.data.total
              this.$message({
                message: resData.msg,
                type: 'success'
              })
          this.loading = false
        }
      } catch (error) {
        console.error(error)
      } finally{
        this.loading = false
      }
    },
    // 新增字典项
    addItemDictionary (formName) {
      this.formLabelAlign = { status: true }
      this.dialogTitle = '新增字典项'
      this.dialogFormVisible = true
    },
    // 提交表单
    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const submitData = { ...this.formLabelAlign }
          submitData.status = submitData.status ? 1 : 0
          submitData.dictCode = this.$route.query.dictCode || ''
          submitData.dictId = this.$route.query.dictId || ''

          const operation = this.dialogTitle === '新增字典项'
            ? addItemDictionary
            : updateItemDictionary

          const res = await operation(submitData)
          if (res.code === 200) {
            this.dialogFormVisible = false
            // 重置表单
            this.$refs[formName].resetFields()
            this.$message.success('操作成功')
            this.getItemDictionaryList()
          } else {
            this.$message.error('操作失败')
          }
        } else {
          console.error('表单验证失败')
          return false
        }
      })
    },
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped></style>
